import { create } from 'zustand';

interface PutEncAfterBlitzModalState {
  isOpen: boolean;
  encId: number;
  onManagePutEncAfterBlitzClose: () => void;
  onManagePutEncAfterBlitzOpen: (encId: number) => void;
}

export const usePutEncAfterBlitzModalStore = create<PutEncAfterBlitzModalState>(set => ({
  isOpen: false,
  encId: 0,
  onManagePutEncAfterBlitzClose: () => set({ isOpen: false, encId: 0 }),
  onManagePutEncAfterBlitzOpen: (encId: number) => set({ isOpen: true, encId }),
}));
